import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IconButton, Link, Tooltip, Typography } from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';
import { HtmlView } from '..';
import { useStyles } from './OwnNotes.styles';
import { INamedEntity } from '../../Api/AptorApi';

interface IProps {
  companyUnits: Array<INamedEntity & { note: string | null }>;
  linkTo?: string;
  compact?: boolean;
}

export const OwnNotes: FC<IProps> = ({ companyUnits, linkTo, compact = false }) => {
  const classes = useStyles();
  const hasMore = companyUnits.filter((x) => x.note).length > 1;
  const firstNote = companyUnits.find((x) => x.note);

  if (!firstNote) {
    return null;
  }

  if (compact) {
    const notes = companyUnits.filter((unit) => unit.note);

    return (
      <Tooltip
        interactive
        placement="top"
        title={(
          <div className={classes.tooltipContent}>
            {notes.map((unit, index) => (
              <div key={`${unit.name}-${index}`} className={classes.note}>
                <Typography variant="overline" component="h4">
                  {unit.name}
                </Typography>
                <HtmlView variant="body2" value={unit.note!} />
              </div>
            ))}
            {linkTo && (
              <Typography variant="body2" className={classes.viewMore}>
                <Link href={linkTo}>
                  <FormattedMessage
                    id="component.own-notes.seeMore"
                    defaultMessage="View more"
                    description="View other notes"
                  />
                </Link>
              </Typography>
            )}
          </div>
        )}
      >
        <IconButton
          size="small"
          aria-label="Show own notes"
          onClick={(event) => event.stopPropagation()}
        >
          <DescriptionIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <>
      <Typography variant="overline" component="h4">
        {firstNote.name}
      </Typography>
      <HtmlView variant="body2" value={firstNote.note!} />
      {hasMore &&
        ((linkTo && (
          <Typography variant="body2">
            <Link href={linkTo}>
              <FormattedMessage
                id="component.own-notes.seeMore"
                defaultMessage="View more"
                description="View other notes"
              />
            </Link>
          </Typography>
        )) || (
          <Typography color="primary" variant="body2" className={classes.fakeLink}>
            <FormattedMessage
              id="component.own-notes.hasMore"
              defaultMessage="View more"
              description="View other notes"
            />
          </Typography>
        ))}
    </>
  );
};
